<template><!-- svgo-optimised -->
<svg class="icon icon__carousel-arrow" viewBox="0 0 8 13" xmlns="http://www.w3.org/2000/svg"><path d="m.354.354 6 6-6 6" stroke="#000"/></svg></template>